export default __webpack_public_path__ + "alberta-fab-send-email.d91353574524936ff616.svg";